import purchaseinvoices from ".";
import * as types from "./types";

const mutations = { 
    [types.LOADING_PURCHASEINVOICES](state, value) {
        state.loading = value;
    },
    [types.GET_PURCHASEINVOICES_LIST](state, purchaseinvoices) {
        state.purchaseinvoices = purchaseinvoices;
    },
    [types.REMOVE_PURCHASEINVOICES](state, id) {        
        state.purchaseinvoices = state.purchaseinvoices.filter((x) => x.id !== id);        
    },
    [types.ADD_PURCHASEINVOICES](state, purchaseinvoices) {        
        state.purchaseinvoices.unshift(purchaseinvoices);
    },
    [types.UPDATE_PURCHASEINVOICES](state, purchaseinvoices) {        
        const purchaseinvoicesIndex = state.purchaseinvoices.findIndex((x) => x.id === purchaseinvoices.id);
        state.purchaseinvoices[purchaseinvoicesIndex] = purchaseinvoices;        
    },
    [types.GET_PURCHASEINVOICESBYID](state, purchaseinvoiceId) {
        state.purchaseinvoiceId = purchaseinvoiceId;
    },
    [types.LOADING_PURCHASE_INVOICE_DOCUMENT](state, value) {
        state.docLoader = value;
    },
    [types.GET_PURCHASE_INVOICE_DOCUMENT_LIST](state, documents) {
        state.documents = documents;
    },
    [types.REMOVE_PURCHASE_INVOICE_DOCUMENT](state, id) {        
        state.documents = state.documents.filter((x) => x.id !== id);        
    },
};

export default mutations;